import type { TokenResponse } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  UserDeviceType,
  useApiContext,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useNavigate } from "@tanstack/react-router"
import {
  useCallback,
  useMemo,
} from "react"

import { ReturningUserFlow } from "./ReturningUserFlow"
import { useAuthContext } from "src/contexts"

const webClientId: string = process.env.REACT_APP_SUGARMATE_OAUTH_CLIENT_ID ?? ""

export function SignIn() {
  const navigate = useNavigate()
  const { setAuthCookie } = useAuthContext()
  const { baseURL } = useApiContext()

  const onSignIn = useMemo(
    () => !baseURL
      ? undefined
      : (response: TokenResponse) => {
        setAuthCookie(
          response,
          baseURL,
        )
        return Promise.resolve()
      },
    [
      setAuthCookie,
      baseURL,
    ],
  )

  const goBack = useCallback(
    () => {
      void navigate({ to: "/" })
    },
    [navigate],
  )

  return (
    <ReturningUserFlow
      deviceType={UserDeviceType.Web}
      clientId={webClientId}
      onSignIn={onSignIn}
      goBack={goBack}
      forgotPasswordRoute="/forgot_password"
    />
  )
}
